import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import type { JsonApiDocument } from '@efdigital/ll-admin-v2/data/normalizers/jsonapi-document';
import type {
  ConsumingPlatform,
  ConsumingPlatformListResponse,
} from '@efdigital/ll-cdk-lti-registration-api-types';

export const LTI_API_PATH = '/ll-lti-registration';

export function isLtiRegistrationUrl(url: string | undefined): boolean {
  return Boolean(url?.includes(LTI_API_PATH));
}

export function consumingPlatformToJsonApiResource(
  platform: ConsumingPlatform
) {
  return {
    type: DataTypeLti.ConsumingPlatform,
    id: platform.id,
    attributes: {
      name: platform.name,
      description: platform.description,
      clientId: platform.clientId,
      platformData: platform.platformData,
      createdAt: platform.createdAt,
      updatedAt: platform.updatedAt,
    },
  };
}

export function consumingPlatformToJsonApiDocument(
  platform: ConsumingPlatform
): JsonApiDocument {
  return {
    data: consumingPlatformToJsonApiResource(platform),
  };
}

export function listConsumingPlatformsResponseToJsonApiDocument(
  response: ConsumingPlatformListResponse
): JsonApiDocument {
  return {
    data: response.map(consumingPlatformToJsonApiResource),
  };
}
